import { v4 as uuidv4 } from 'uuid'

const STORAGE_KEY = 'pseudo_user_id'

export function getPseudoUserId(): string {
  let id = sessionStorage.getItem(STORAGE_KEY)
  if (!id) {
    id = uuidv4()
    sessionStorage.setItem(STORAGE_KEY, id)
  }
  return id
}

// 비회원 사용 제한을 위한 로컬 스토리지 기반 함수
export function checkNonMemberUsage(
  pseudoUserId: string,
  type: string = 'parse',
  limit: number = 3 // 해당 타입의 기능에 대한 하루 사용 제한 횟수
): { canUse: boolean, remainingUses: number } {
  // 오늘 날짜 (한국 시간) 계산
  const now = new Date()
  const koreaTime = new Date(now.getTime() + (9 * 60 * 60 * 1000))
  const today = koreaTime.toISOString().split('T')[0]
  
  // 로컬 스토리지 키 생성
  const storageKey = `usage_limit_${pseudoUserId}_${type}_${today}`
  
  // 현재 사용량 조회
  const currentUsageStr = localStorage.getItem(storageKey)
  const currentUsage = currentUsageStr ? parseInt(currentUsageStr, 10) : 0
  
  // 남은 사용 가능 횟수 계산 (전달받은 limit 사용)
  const remainingUses = Math.max(0, limit - currentUsage)
  
  return {
    canUse: remainingUses > 0,
    remainingUses,
  }
}

// 비회원 사용량 카운터 증가
export function incrementNonMemberUsage(pseudoUserId: string, type: string = 'parse'): void {
  // 오늘 날짜 (한국 시간) 계산
  const now = new Date()
  const koreaTime = new Date(now.getTime() + (9 * 60 * 60 * 1000))
  const today = koreaTime.toISOString().split('T')[0]
  
  // 로컬 스토리지 키 생성
  const storageKey = `usage_limit_${pseudoUserId}_${type}_${today}`
  
  // 현재 사용량 조회 및 증가
  const currentUsageStr = localStorage.getItem(storageKey)
  const currentUsage = currentUsageStr ? parseInt(currentUsageStr, 10) : 0
  
  // 사용량 증가 및 저장
  localStorage.setItem(storageKey, String(currentUsage + 1))
} 